import { useContext } from 'react'
import PropTypes from 'prop-types'

import {
  Box,
  Button,
  Checkbox,
  ListItem,
  ModalContext,
  SidebarModal,
  Text,
} from '@domain-group/suit-theme'

import { deepSetObject, digObject, toggleArray } from '@domain-group/javascript-utils'

import useProvider, { useProviderForm } from '@hooks/useProvider'

import ModalSubheader from '@components/ModalComponents/ModalSubHeader'

const handleCheckDay = (providerForm, value) => {
  const { entityState: { options }, setEntityState } = providerForm

  const closedDaysArray = digObject(options, 'closed_days', [])
  const updatedClosedDays = toggleArray(closedDaysArray, value)
  const updatedOptions = deepSetObject(options, 'closed_days', updatedClosedDays)

  setEntityState({ options: updatedOptions })
}

const EditProviderTradingDaysModal = (props) => {
  const { callbacks, modalKey, showModal } = props
  const { closeModal, updateProvider } = callbacks

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const { provider } = digObject(modalData, modalKey, {})

  const providerPayload = useProvider(provider)
  const {
    callbacks: {
      updateProvider: updateFn,
    },
    updating,
  } = providerPayload

  const providerForm = useProviderForm(provider)
  const {
    entityState,
    entityState: {
      options,
      title,
    },
  } = providerForm

  const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
  const closedDays = digObject(options, 'closed_days', [])

  const updateProviderPayload = {
    callbacks: {
      action: updateFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    toastText: 'Trading Days Updated',
  }

  return (
    <SidebarModal
      callbacks={callbacks}
      modalKey={modalKey}
      showModal={showModal}
      size="small"
    >
      <SidebarModal.Header
        callbacks={callbacks}
        title="Trading"
        titleSecondLine="Days"
      />

      <ModalSubheader
        ownerTitle={title}
        title="Managing Trading Days for"
      />

      <SidebarModal.Content>
        <Box flexDirection="column" marginTop="large" marginBottom="large">
          <Text color="mysteryGrey" fontSize="xsmall">Service Options</Text>
        </Box>

        {days.map((day, index) => (
          <ListItem.WithCheckbox
            boxProps={{ border: 'none' }}
            checkbox={(
              <Checkbox
                checked={!closedDays.includes(index + 1)}
                onClick={() => handleCheckDay(providerForm, index + 1)}
              />
            )}
            disableHover
            key={day}
          >
            <Box color="bodyFontColor" fontSize="small">
              {day}
            </Box>
          </ListItem.WithCheckbox>
        ))}
      </SidebarModal.Content>

      <SidebarModal.Footer>

        <Button
          buttonStyle="primaryCreate"
          loading={updating}
          onClick={() => updateProvider(updateProviderPayload)}
          size="large"
        >
          Save Trading Days
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

EditProviderTradingDaysModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

EditProviderTradingDaysModal.defaultProps = {
  modalKey: 'EditProviderTradingDaysModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <EditProviderTradingDaysModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
